export const PENDING_ACTIVATION = "Pending Activation";
export const ACTIVE = "Active";
export const PENDING_DEACTIVATION = "Pending Deactivation";
